/*global google*/

export const getUserCurrentLocation = async () => {
  return new Promise((resolve, reject) => {
    return navigator.geolocation.getCurrentPosition(
      (position) => resolve(position),
      (err) => reject(err),
      {
        timeout: 20 * 1000,
      }
    );
  });
};

// public/index.html loads the Maps API with `async` now, so window.google is
// not there at mount any more — it appears whenever Google answers. The loader
// resolves whenGoogleMapsReady() from its `callback`, and this is the only
// place in the app that reaches for google.maps outside a React component.
export const locationFromCoords = async (lat, long) => {
  if (typeof window.whenGoogleMapsReady === "function") {
    await window.whenGoogleMapsReady();
  }
  const geocoder = new google.maps.Geocoder();
  const latlng = new google.maps.LatLng(lat, long);
  return new Promise((resolve, reject) => {
    return geocoder.geocode(
      {
        latLng: latlng,
      },
      function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            resolve(results[0]);
          } else {
            reject("No results found");
          }
        } else {
          reject("Geocoder failed due to: " + status);
        }
      }
    );
  });
};
